import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[mcrai-menu-item]',
  template: `<div #template>
  <ng-content></ng-content>
</div>`,
  styles: [`[mcrai-menu-item]{display:block;align-items:center;justify-content:flex-start;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:background-color .2s;padding:10px 20px;flex:0 0 44px;text-decoration:none;background:0;border:0;font-size:16px;text-align:left;outline:0;transition-timing-function:cubic-bezier(.25,.8,.25,1)}`],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-menu-item]': 'true'
  }
})
export class MenuItemComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
